(function () {
	'use strict';

	angular.module('dcApp').service('GrammarUtils', [
		'FIELD_FUNCTION_OPERATION',
		'gettextCatalog',
		'$q',
		function (FIELD_FUNCTION_OPERATION, gettextCatalog, $q) {
			this.isFunctionAllowedForType = function (fn, colType) {
				if (fn.code === 'CONCAT' && colType !== 'string') {
					return false;
				}
				if (colType === 'string' || colType === 'file') {
					return (
						fn.code === 'CONCAT' ||
						fn.code === 'COUNT_DISTINCT' ||
						fn.code === 'COUNT_DISTINCT_APPROX' ||
						fn.code === 'COUNT' ||
						fn.code === 'COLLECT_LIST' ||
						fn.code === 'COLLECT_SET' ||
						fn.code === 'LEAD' ||
						fn.code === 'LAG' ||
						fn.code === 'FIRST' ||
						fn.code === 'LAST' ||
						fn.code === 'FIRST_VALUE' ||
						fn.code === 'LAST_VALUE'
					);
				}
				if (colType === 'boolean') {
					return (
						fn.code === 'COUNT_DISTINCT' ||
						fn.code === 'COUNT_DISTINCT_APPROX' ||
						fn.code === 'COUNT' ||
						fn.code === 'COLLECT_LIST' ||
						fn.code === 'COLLECT_SET'
					);
				}
				if (colType === 'words') {
					return (
						fn.code === 'COUNT_DISTINCT' ||
						fn.code === 'COUNT_DISTINCT_APPROX' ||
						fn.code === 'COUNT' ||
						fn.code === 'COLLECT_LIST' ||
						fn.code === 'COLLECT_SET'
					);
				}
				if (colType === 'time' || colType === 'date') {
					return (
						fn.code === 'MAX' ||
						fn.code === 'MIN' ||
						fn.code === 'COUNT_DISTINCT' ||
						fn.code === 'COUNT_DISTINCT_APPROX' ||
						fn.code === 'COUNT' ||
						fn.code === 'COLLECT_LIST' ||
						fn.code === 'COLLECT_SET' ||
						fn.code === 'LEAD' ||
						fn.code === 'LAG' ||
						fn.code === 'FIRST' ||
						fn.code === 'LAST' ||
						fn.code === 'FIRST_VALUE' ||
						fn.code === 'LAST_VALUE'
					);
				}

				return (
					colType === 'integer' ||
					colType === 'double' ||
					colType === 'decimal' ||
					colType === 'big_integer'
				);
			};

			this.isFunctionAllowedForAggregationType = function (
				fn,
				aggregationType
			) {
				const countDistinctFnRule =
					fn.code === FIELD_FUNCTION_OPERATION.distinctCount &&
					(Number(aggregationType) === 1 || Number(aggregationType) === 0);
				const otherFnRule =
					(fn.code === FIELD_FUNCTION_OPERATION.lead ||
						fn.code === FIELD_FUNCTION_OPERATION.lag ||
						fn.code === FIELD_FUNCTION_OPERATION.first ||
						fn.code === FIELD_FUNCTION_OPERATION.last ||
						fn.code === FIELD_FUNCTION_OPERATION.firstValue ||
						fn.code === FIELD_FUNCTION_OPERATION.lastValue) &&
					Number(aggregationType) !== 1;
				return !countDistinctFnRule && !otherFnRule;
			};

			this.getFuncType = function (func, type, is_list) {
				let funcType = {};
				// Determine type for each method
				switch (func) {
					case 'COUNT':
					case 'COUNT_DISTINCT':
					case 'COUNT_DISTINCT_APPROX':
					case 'COUNT_NOT_NULL_NAN':
						funcType.type = 'big_integer';
						break;
					case 'AVG':
					case 'MEDIAN':
					case 'STDDEV_POP':
					case 'VARIANCE':
						funcType.type = 'decimal';
						break;
					case 'CONCAT':
						funcType.type = 'string';
						break;
					case 'SUM':
						funcType.type = type === 'integer' ?
							'big_integer' : type;
						break;
					case 'COLLECT_LIST':
					case 'COLLECT_SET':
						funcType.type = type;
						funcType.is_list = true;
						break;
					case 'MAX':
					case 'MIN':
					case 'LEAD':
					case 'LAG':
					case 'FIRST':
					case 'LAST':
					case 'FIRST_VALUE':
					case 'LAST_VALUE':
					case 'NULL':
						funcType.type = type;
						funcType.is_list = is_list;
						break;
					default:
						break;
				}
				funcType.is_list = funcType.is_list == null ?
					false : funcType.is_list;
				return funcType;
			}

			this.getTypeLabel = function (type) {
				switch (type) {
					case 'string':
						return gettextCatalog.getString('Chaîne de caractères');
					case 'file':
						return gettextCatalog.getString('Fichier');
					case 'decimal':
						return gettextCatalog.getString('Nombre décimal');
					case 'double':
						return gettextCatalog.getString('Nombre décimal');
					case 'date':
						return gettextCatalog.getString('Date');
					case 'integer':
						return gettextCatalog.getString('Nombre entier (<2 Md)');
					case 'big_integer':
						return gettextCatalog.getString('Grand nombre entier');
					case 'boolean':
						return gettextCatalog.getString('Booléen');
					case 'binary':
						return gettextCatalog.getString('Binaire');
					case 'words':
						return gettextCatalog.getString('Mots');
					case 'geometry':
						return gettextCatalog.getString('Géométrie');
					default:
						break;
				}
			};

			this.checkUnionAfterStep = function (steps, step, startFromNext) {
				// Steps is actually an array
				if (!steps || !Array.isArray(steps)) {
						return $q.resolve({ data: false });
				}
				// Find the starting index
				// If the step isn't found in the array, start from 0
				let startIndex = steps.indexOf(step);
				startIndex = startIndex === -1 ? 0 : startIndex;
				// Starting from current or from next step
				if (startFromNext) {
					startIndex = startIndex + 1;
				}
				// If we are past the last element, there are definitely no unions after
          if (startIndex >= steps.length) {
            return $q.resolve({ data: false });
          }
				// Check for unions from startIndex to the end
				const unionExists = steps.slice(startIndex).some(s => s.unions && s.unions.length > 0);

				return $q.resolve({ data: unionExists });
      };
		},
	]);
})();
